import React, { useState, useContext, useRef, useEffect } from "react";
import LanguageContext from "../LanguageContext";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const labelMap = {
  fr: "Changer de langue - Change language - 切换语言",
  en: "Changer de langue - Change language - 切换语言",
  zh: "Changer de langue - Change language - 切换语言",
};

const menuLabels = {
  presentation: {
    fr: "Notice du Code des Millésimes",
    en: "Vintage Code notice",
    zh: "复古代码传单"
  },
  millesimes: {
    fr: "Le Code des Millésimes par l'Académie du Vin de Bordeaux",
    en: "The vintage Code by the Académie du Vin de Bordeaux",
    zh: "波尔多葡萄酒学院年份代码"
  },
  chateaux: {
    fr: "Membres Associés de l’Académie du Vin de Bordeaux",
    en: "Associate Members of the Académie du Vin de Bordeaux",
    zh: "波尔多葡萄酒学院的准会员"
  },
  degustation: {
    fr: "Pour votre dégustation",
    en: "Tasting tips",
    zh: "供您品尝"
  },
  credits: {
    fr: "Crédits",
    en: "Credits",
    zh: "鸣谢"
  }
};

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  const menuRef = useRef();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const menuItemStyle = {
    paddingTop: '1rem',
    paddingBottom: '0.25rem',
    fontSize: '1.1rem',
    cursor: 'pointer',
    textAlign: 'left'
  };

  return (
    <div
      className="menu-root"
      ref={menuRef}
      style={{ position: 'relative', zIndex: 50 }}
    >
      <button
        onClick={toggleMenu}
        style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
        aria-haspopup="menu"
        aria-expanded={isOpen}
      >
        <img
          src="/media/menu.png"
          alt="menu icon"
          style={{ width: "64px", height: "83px", objectFit: "contain", display: "block" }}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.nav
            // Aligner le menu sous le logo : coin supérieur gauche aligné sur le bouton
            style={{
              position: 'absolute',
              left: 0,
              top: '100%',
              backgroundColor: '#f2f2f6', // enveloppe grisée
              color: '#000',
              border: '1px solid rgba(0,0,0,0.15)',
              borderRadius: '5px',
              boxShadow: '0 10px 15px rgba(0,0,0,0.10), 0 4px 6px rgba(0,0,0,0.06)',
              padding: '8px',
              minWidth: '220px'
            }}
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            transition={{ duration: 0.16 }}
            role="menu"
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div onClick={() => handleNavigate('/wine')} style={menuItemStyle} role="menuitem">
                {menuLabels.millesimes[language]}
              </div>
              <div onClick={() => handleNavigate('/presentation')} style={menuItemStyle} role="menuitem">
                {menuLabels.presentation[language]}
              </div>
              <div onClick={() => handleNavigate('/chateaux')} style={menuItemStyle} role="menuitem">
                {menuLabels.chateaux[language]}
              </div>
              <div onClick={() => handleNavigate('/degustation')} style={menuItemStyle} role="menuitem">
                {menuLabels.degustation[language]}
              </div>
              <div onClick={() => handleNavigate('/credits')} style={menuItemStyle} role="menuitem">
                {menuLabels.credits[language]}
              </div>
              <div onClick={() => handleNavigate('/')} style={menuItemStyle} role="menuitem">
                {labelMap[language]}
              </div>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Menu;
